import type { ComponentType } from 'react';

import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Snackbar from './Snackbar';
import { removeMessage } from './SnackbarActions';

function mapDispatchToProps(dispatch: any) {
  return {
    removeMessage: bindActionCreators(removeMessage, dispatch),
  };
}

function mapStateToProps(state: any) {
  return {
    messages: state.snackbar.messages,
  };
}

const connector = connect(mapStateToProps, mapDispatchToProps);
export type SnackbarContainerProps = ConnectedProps<typeof connector>;

const ConnectedSnackbar: ComponentType = connector(Snackbar);
export default ConnectedSnackbar;
